import { CalendarClock, Gauge, X } from "lucide-react";

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const dueState = (c) => {
  if (!c.callback_date) return null;
  const t = todayStr();
  if (c.callback_date < t) return "late";
  return c.callback_date === t ? "today" : "future";
};

export const isDue = (c) => ["today", "late"].includes(dueState(c));

export const level = (score) => {
  if (score >= 75) return { label: "Pronto", color: "#98bfa2" };
  if (score >= 50) return { label: "Da valutare", color: "#e8d48b" };
  return { label: "Poco pronto", color: "#f0a78f" };
};

export const ScoreBadge = ({ c }) => {
  const l = level(c.score ?? 0);
  return (
    <div data-testid={`coaching-score-${c.id}`} title="Indicativo: tempo (30) + motivazione (35) + disponibilità (35)"
      className="flex items-center gap-3 border px-3 py-2" style={{ borderColor: l.color }}>
      <Gauge size={16} style={{ color: l.color }} />
      <span className="font-display text-2xl font-900 leading-none">{c.score ?? 0}</span>
      <span className="font-mono text-[11px] uppercase tracking-widest" style={{ color: l.color }}>{l.label}</span>
    </div>
  );
};

const DUE_LABEL = { today: ["Da sentire oggi", "#e8d48b"], late: ["Richiamo scaduto", "#f0a78f"] };

export const CallbackPicker = ({ c, onChange }) => {
  const state = dueState(c);
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid={`coaching-callback-${c.id}`}>
      <CalendarClock size={14} className="text-[#98bfa2]" />
      <span className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">Richiamare il</span>
      <input type="date" data-testid={`coaching-callback-input-${c.id}`} value={c.callback_date || ""}
        onChange={(e) => onChange(c, { callback_date: e.target.value })}
        className="border border-white/15 bg-[#0b120e] px-2 py-1 font-mono text-xs text-[#f4f7f5] [color-scheme:dark]" />
      {c.callback_date && (
        <button type="button" data-testid={`coaching-callback-clear-${c.id}`} onClick={() => onChange(c, { callback_date: "" })} aria-label="Rimuovi data" className="p-1 text-[#a3b1aa] hover:text-[#f0a78f]"><X size={14} /></button>
      )}
      {DUE_LABEL[state] && (
        <span data-testid={`coaching-due-badge-${c.id}`} className="rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-[#050807]" style={{ background: DUE_LABEL[state][1] }}>
          {DUE_LABEL[state][0]}
        </span>
      )}
    </div>
  );
};
